// Translation dictionaries
export const translations = {
  english: {
    // App Bar
    appTitle: process.env.REACT_APP_APP_NAME || "Precision Politics",
    settings: "Settings",
    logout: "Logout",
    welcome: "Welcome",
    
    // Main Dashboard
    trumpApprovalAnalysis: "Presidential Job Approval Analysis",
    description: "Multilevel Regression and Poststratification (MRP) analysis of Trump job approval ratings across US states with demographic filters.",
    
    // Navigation
    trumpJobApproval: "Job Approval Analysis",
    surveyResponseHeatmap: "Survey Response Heatmap",
    rawDataVisualization: "Raw Data Visualization",
    dashboardNavigation: "Dashboard Navigation",
    jobApprovalTab: "Job Approval Analysis",
    
    // Demographics
    demographicFilters: "Demographic Filters",
    ageGroup: "Age Group",
    raceGroup: "Race Group",
    partyGroup: "Party Group",
    clearFilters: "Clear Filters",
    gender: "Gender",
    raceEthnicity: "Race/Ethnicity",
    incomeLevel: "Income Level",
    partyAffiliation: "Party Affiliation",
    activeFilters: "Active Filters",
    
    // Stats
    averageApproval: "Average Approval",
    highestApproval: "Highest Approval",
    lowestApproval: "Lowest Approval",
    averageDisapproval: "Average Disapproval",
    averageNoOpinion: "Average No Opinion",
    trumpDisapproval: "Disappr.",
    trumpNoOpinion: "N.Opin.",
    totalPopulation: "Total Population",
    summaryStatistics: "Summary Statistics",
    basedOnStates: "Based on {count} states",
    outOfFive: "Out of 5.0",
    samplePopulation: "Sample population",
    approvalRatingsRange: "Approval ratings range from {min} to {max} with a standard deviation of {stdDev}.",
    allDemographics: "All Demographics",
    age: "Age",
    race: "Race",
    party: "Party",
    politicalParty: "Political Party",
    allAges: "All Ages",
    allRaces: "All Races",
    allParties: "All Parties",
    allGenders: "All Genders",
    allEducation: "All Education Levels",
    allIncome: "All Income Levels",
    allDensity: "All Population Densities",
    education: "Education",
    income: "Income",
    density: "Population Density",
    filterInstructions: "Select demographic filters to see Trump job approval ratings for specific population segments.",
    
    // Map
    trumpApprovalByState: "Trump Job Approval by State",
    selected: "Selected",
    
    // Settings
    appearance: "Appearance",
    themeMode: "Theme Mode",
    light: "Light",
    dark: "Dark",
    system: "System",
    language: "Language",
    selectLanguage: "Select Language",
    english: "English",
    italian: "Italiano",
    close: "Close",
    
    // Login
    signIn: "Sign In",
    username: "Username",
    password: "Password",
    signingIn: "Signing In...",
    demoLogin: "Demo Login - Enter any username and password",
    suggested: "Suggested: admin / password",
    
    // Footer
    copyright: "Copyright © 2025 Rajant Health Inc.",
    
    // Data
    noDataAvailable: "No data available",
    noData: "No data",
    loading: "Loading...",
    error: "Error",
    
        // Heatmap
    genderOptions: "Gender Options",
    ageOptions: "Age Options",
    raceOptions: "Race Options",
    incomeOptions: "Income Options",
    partyOptions: "Party Options",
    filtersApplied: "Filters Applied",
    geographicDistribution: "Geographic Distribution of Survey Responses",
    totalResponses: "Total Responses",
    statesCovered: "States Covered",
    avgPerState: "Avg per State",
    
    // Raw Data
    selectChartType: "Select Chart Type",
    totalSamples: "Total Samples",
    uniqueZips: "Unique ZIP Codes",
    responseCount: "Response Count",
    totalSamplesPerState: "Total Number of Samples per State",
    uniqueZipsPerState: "Number of Unique ZIP Codes Covered per State",
    sampleCountDistribution: "Distribution of Sample Counts per ZIP Code",
    ageDistribution: "Age Distribution Nationwide",
    raceDistribution: "Race Distribution Nationwide",
    genderDistribution: "Gender Distribution Nationwide",
    educationDistribution: "Education Level Distribution Nationwide",
    swingStatesZips: "Suitable ZIPs (5+ samples) per 2024 Swing States",
    avgPopulationByState: "Average Population per ZIP Code by State",
    avgIncomeByState: "Average Income per Household by State",
    rawDataVisualizationTitle: "Raw Data Visualization",
    rawDataVisualizationDescription: "Explore comprehensive data analysis and visualizations based on survey data, ZIP code coverage, and demographic distributions.",
    totalZipCodes: "Total ZIP Codes",
    sampleRanges: "Sample Ranges",
    avgPerRange: "Avg per Range",
    totalParticipants: "Total Participants",
    categories: "Categories",
    avgPerCategory: "Avg per Category",
    totalSuitableZips: "Total Suitable ZIPs",
    swingStates: "Swing States",
    totalStates: "Total States",
    dataPoints: "Data Points",
    coverage: "Coverage",
    
    // Data Table
    state: "ST",
    approvalRating: "Approval Rating",
    population: "Population",
    weighted: "Weighted",
    trumpApproval: "Appr.",
    weightedPop: "Weighted Pop.",
    
    // Login errors
    enterUsernamePassword: "Please enter both username and password",
    
      // Trump Approval Map
  trumpApprovalHover: "Approval",
    trumpJobApprovalTitle: "Trump Job Approval",
    
    // Heatmap specific
    interactiveVisualization: "Interactive visualization of survey response distribution across US states by demographic characteristics.",
    clearAllFilters: "Clear All Filters",
    errorLoadingHeatmap: "Error loading heatmap. Please try again.",
    surveyResponseHeatmapTitle: "Survey Response Heatmap by State",
    
    // Chart specific
    chartResponseCount: "Response Count",
    chartErrorLoading: "Error loading chart. Please try again.",
    chartNoData: "No data available to display",
    
    // Chart titles for RawDataVisualization
    chartTotalSamplesPerState: "Total Number of Samples per State",
    chartUniqueZipsPerState: "Number of Unique ZIP Codes Covered per State", 
    chartSampleCountDistribution: "Distribution of Sample Counts per ZIP Code",
    chartAgeDistributionNationwide: "Age Distribution Nationwide",
    chartRaceDistributionNationwide: "Race Distribution Nationwide",
    chartGenderDistributionNationwide: "Gender Distribution Nationwide",
    chartEducationDistributionNationwide: "Education Level Distribution Nationwide",
    chartSuitableZipsSwingStates: "Suitable ZIPs (5+ samples) per 2024 Swing States",
    chartTop15PopulationByState: "Top 15 States by Average Population per ZIP Code",
    chartTop15IncomeByState: "Top 15 States by Average Income per Household",
    
    // Chart axis labels
    axisState: "State",
    axisNumberOfSamples: "Number of Samples",
    axisNumberOfZipCodes: "Number of ZIP Codes",
    axisSampleCountRange: "Sample Count Range",
    axisAgeGroup: "Age Group",
    axisNumberOfParticipants: "Number of Participants",
    axisRaceGroup: "Race Group",
    axisGender: "Gender", 
    axisEducationLevel: "Education Level",
    axisSwingState: "Swing State",
    axisNumberOfSuitableZipCodes: "Number of Suitable ZIP Codes",
    axisAveragePopulationPerZip: "Average Population per ZIP Code",
    axisAverageIncomePerHousehold: "Average Income per Household ($)",
    
    // Chart data labels
    chartSamples: "Samples",
    chartZipCodes: "ZIP Codes",
    chartParticipants: "Participants",
    chartSuitableZips: "Suitable ZIPs",
    chartAveragePopulation: "Average Population",
    chartAverageIncome: "Average Income",
    
    // Demographic Values
    "10-19": "10-19",
    "20-29": "20-29",
    "30-39": "30-39",
    "40-49": "40-49",
    "50+": "50+",
    "18-29": "18-29",
    "30-44": "30-44", 
    "45-64": "45-64",
    "65+": "65+",
    "Male": "Male",
    "Female": "Female",
    "White": "White",
    "Black": "Black",
    "Hispanic": "Hispanic",
    "Asian": "Asian",
    "Other": "Other",
    "Democrat": "Democrat",
    "Republican": "Republican", 
    "Independent": "Independent",
    "Low": "Low",
    "Medium": "Medium",
    "High": "High",
    "Rural": "Rural",
    "Suburban": "Suburban",
    "Urban": "Urban",
    "1.0": "Less than High School",
    "2.0": "High School Graduate",
    "3.0": "Some College",
    "4.0": "Bachelor's Degree",
    "5.0": "Graduate Degree",
    "Less than $25,000": "Less than $25,000",
    "$25,000 - $49,999": "$25,000 - $49,999",
    "$50,000 - $74,999": "$50,000 - $74,999",
    "$75,000 - $99,999": "$75,000 - $99,999",
    "$100,000+": "$100,000+",
    "All": "All",
    
    // Home Page
    home: "Home",
    homeTitle: "Precision Politics",
    homeSubtitle: "Electoral Intelligence, Engineered!",
    aboutThisPlatform: "About This Platform",
    homeAboutParagraph1: "Precision Politics is an AI-powered insights platform that brings clarity to chaos in modern political landscapes. By synthesizing vast datasets—polls, legislation, media narratives, and demographic trends—it delivers hyper-targeted, real-time intelligence to campaigns, advocacy groups, and civic tech organizations. The result: smarter messaging, faster responses, and data-backed strategies that resonate precisely where it matters. This is Electoral Intelligence, Engineered.",
    homeAboutParagraph2: "It currently provides an interactive interface for analyzing Trump job approval data through three main features: state-level approval analysis, survey response visualization, and raw data exploration.",
    electionIntelligenceTitle: "Job Approval Analysis",
    electionIntelligenceDescription: "Our most advanced analysis employing a custom-tailored, gold-standard model amongst pollsters, allowing for accurate predictions down to a state-level granularity with interactive US maps and demographic filtering.",
    surveyHeatmapDescription: "Visualizes the dataset itself, showing potential gaps in surveys amongst demographic slices. Helps understand potential biases or skews in data with real-time statistics and dynamic updates.",
    rawDataDescription: "Expands data exploration capabilities, allowing clear visualization of nationwide information and demonstrating exactly how survey data translates to the US as a whole through multiple chart types.",
    stateLevelAnalysis: "State-Level Analysis",
    geographicDistributionText: "Geographic Distribution",
    comprehensiveCharts: "Comprehensive Charts",
    exploreText: "Explore",
  },
  
  italian: {
    // App Bar
    appTitle: process.env.REACT_APP_APP_NAME || "Politica di Precisione",
    settings: "Impostazioni",
    logout: "Disconnetti",
    welcome: "Benvenuto",
    
    // Main Dashboard
    trumpApprovalAnalysis: "Analisi Approvazione Presidenziale",
    description: "Analisi di regressione multilivello e poststratificazione (MRP) dei tassi di approvazione di Trump negli stati degli USA con filtri demografiche.",
    
    // Navigation
    trumpJobApproval: "Analisi Approvazione Lavoro",
    surveyResponseHeatmap: "Mappa di Calore delle Risposte al Sondaggio",
    rawDataVisualization: "Visualizzazione Dati Grezzi",
    dashboardNavigation: "Navigazione Dashboard",
    jobApprovalTab: "Analisi Approvazione Lavoro",
    
    // Demographics
    demographicFilters: "Filtri Demografici",
    ageGroup: "Gruppo d'Età",
    raceGroup: "Gruppo Razziale",
    partyGroup: "Gruppo Politico",
    clearFilters: "Cancella Filtri",
    gender: "Genere",
    raceEthnicity: "Razza/Etnia",
    incomeLevel: "Livello di Reddito",
    partyAffiliation: "Affiliazione Politica",
    activeFilters: "Filtri Attivi",
    
    // Stats
    averageApproval: "Approvazione Media",
    highestApproval: "Max Approvazione",
    lowestApproval: "Approvazione Minima",
    averageDisapproval: "Disapprovazione Media",
    averageNoOpinion: "Nessuna Opinione Media",
    trumpDisapproval: "Disappr.",
    trumpNoOpinion: "N.Opin.",
    totalPopulation: "Popolazione Totale",
    summaryStatistics: "Statistiche Riassuntive",
    basedOnStates: "Basato su {count} stati",
    outOfFive: "Su 5.0",
    samplePopulation: "Popolazione campione",
    approvalRatingsRange: "Le valutazioni di approvazione vanno da {min} a {max} con una deviazione standard di {stdDev}.",
    allDemographics: "Tutte le Caratteristiche Demografiche",
    age: "Età",
    race: "Razza",
    party: "Partito",
    politicalParty: "Partito Politico",
    allAges: "Tutte le Età",
    allRaces: "Tutte le Razze",
    allParties: "Tutti i Partiti",
    allGenders: "Tutti i Generi",
    allEducation: "Tutti i Livelli di Istruzione",
    allIncome: "Tutti i Livelli di Reddito",
    allDensity: "Tutte le Densità di Popolazione",
    education: "Istruzione",
    income: "Reddito",
    density: "Densità di Popolazione",
    filterInstructions: "Seleziona i filtri demografici per vedere le valutazioni di approvazione di Trump per segmenti di popolazione specifici.",
    
    // Map
    trumpApprovalByState: "Approvazione di Trump per Stato",
    selected: "Selezionato",
    
    // Settings
    appearance: "Aspetto",
    themeMode: "Modalità Tema",
    light: "Chiaro",
    dark: "Scuro",
    system: "Sistema",
    language: "Lingua",
    selectLanguage: "Seleziona Lingua",
    english: "Inglese",
    italian: "Italiano",
    close: "Chiudi",
    
    // Login
    signIn: "Accedi",
    username: "Nome Utente",
    password: "Password",
    signingIn: "Accesso in corso...",
    demoLogin: "Login Demo - Inserisci qualsiasi nome utente e password",
    suggested: "Suggerito: admin / password",
    
    // Footer
    copyright: "Copyright © 2025 Rajant Health Inc.",
    
    // Data
    noDataAvailable: "Nessun dato disponibile",
    noData: "Nessun dato",
    loading: "Caricamento...",
    error: "Errore",
    
    // Heatmap
    genderOptions: "Opzioni Genere",
    ageOptions: "Opzioni Età",
    raceOptions: "Opzioni Razza",
    incomeOptions: "Opzioni Reddito",
    partyOptions: "Opzioni Partito",
    filtersApplied: "Filtri Applicati",
    geographicDistribution: "Distribuzione Geografica delle Risposte al Sondaggio",
    
    // Raw Data
    selectChartType: "Seleziona Tipo di Grafico",
    totalSamples: "Campioni Totali",
    uniqueZips: "Codici ZIP Unici",
    responseCount: "Conteggio Risposte",
    totalSamplesPerState: "Numero Totale di Campioni per Stato",
    uniqueZipsPerState: "Numero di Codici ZIP Unici Coperti per Stato",
    sampleCountDistribution: "Distribuzione del Conteggio dei Campioni per Codice ZIP",
    ageDistribution: "Distribuzione dell'Età a Livello Nazionale",
    raceDistribution: "Distribuzione Razziale a Livello Nazionale",
    genderDistribution: "Distribuzione di Genere a Livello Nazionale",
    educationDistribution: "Distribuzione del Livello di Istruzione a Livello Nazionale",
    swingStatesZips: "ZIP Adatti (5+ campioni) per Stati Swing 2024",
    avgPopulationByState: "Popolazione Media per Codice ZIP per Stato",
    avgIncomeByState: "Reddito Medio per Famiglia per Stato",
    rawDataVisualizationTitle: "Visualizzazione Dati Grezzi",
    rawDataVisualizationDescription: "Esplora analisi dati completa e visualizzazioni basate su dati del sondaggio, copertura dei codici ZIP e distribuzioni demografiche.",
    totalResponses: "Risposte Totali",
    statesCovered: "Stati Coperti",
    avgPerState: "Media per Stato",
    totalZipCodes: "Codici ZIP Totali",
    sampleRanges: "Intervalli di Campioni",
    avgPerRange: "Media per Intervallo",
    totalParticipants: "Partecipanti Totali",
    categories: "Categorie",
    avgPerCategory: "Media per Categoria",
    totalSuitableZips: "ZIP Adatti Totali",
    swingStates: "Stati Swing",
    totalStates: "Stati Totali",
    dataPoints: "Punti Dati",
    coverage: "Copertura",
    
    // Data Table
    state: "ST",
    approvalRating: "Valutazione Approvazione",
    population: "Popolazione",
    weighted: "Ponderato",
    trumpApproval: "Appr.",
    weightedPop: "Pop. Ponderata",
    
    // Login errors
    enterUsernamePassword: "Inserisci nome utente e password",
    
      // Trump Approval Map
  trumpApprovalHover: "Approvazione",
    trumpJobApprovalTitle: "Approvazione Lavoro Trump",
    
    // Heatmap specific
    interactiveVisualization: "Visualizzazione interattiva della distribuzione delle risposte al sondaggio negli stati degli USA per caratteristiche demografiche.",
    clearAllFilters: "Cancella Tutti i Filtri",
    errorLoadingHeatmap: "Errore nel caricamento della mappa di calore. Riprova.",
    surveyResponseHeatmapTitle: "Mappa di Calore delle Risposte al Sondaggio per Stato",
    
    // Chart specific
    chartResponseCount: "Conteggio Risposte",
    chartErrorLoading: "Errore nel caricamento del grafico. Riprova.",
    chartNoData: "Nessun dato disponibile per la visualizzazione",
    
    // Chart titles for RawDataVisualization
    chartTotalSamplesPerState: "Numero Totale di Campioni per Stato",
    chartUniqueZipsPerState: "Numero di Codici ZIP Unici Coperti per Stato", 
    chartSampleCountDistribution: "Distribuzione del Conteggio dei Campioni per Codice ZIP",
    chartAgeDistributionNationwide: "Distribuzione dell'Età a Livello Nazionale",
    chartRaceDistributionNationwide: "Distribuzione Razziale a Livello Nazionale",
    chartGenderDistributionNationwide: "Distribuzione di Genere a Livello Nazionale",
    chartEducationDistributionNationwide: "Distribuzione del Livello di Istruzione a Livello Nazionale",
    chartSuitableZipsSwingStates: "ZIP Adatti (5+ campioni) per Stati Swing 2024",
    chartTop15PopulationByState: "Stati con Media Popolazione Media per Codice ZIP",
    chartTop15IncomeByState: "Stati con Reddito Medio Famiglia",
    
    // Chart axis labels
    axisState: "Stato",
    axisNumberOfSamples: "Numero di Campioni",
    axisNumberOfZipCodes: "Numero di Codici ZIP",
    axisSampleCountRange: "Intervallo di Conteggio Campione",
    axisAgeGroup: "Gruppo d'Età",
    axisNumberOfParticipants: "Numero di Partecipanti",
    axisRaceGroup: "Gruppo Razziale",
    axisGender: "Genere", 
    axisEducationLevel: "Livello di Istruzione",
    axisSwingState: "Stato Swing",
    axisNumberOfSuitableZipCodes: "Numero di Codici ZIP Adatti",
    axisAveragePopulationPerZip: "Popolazione Media per Codice ZIP",
    axisAverageIncomePerHousehold: "Reddito Medio Famiglia ($)",
    
    // Chart data labels
    chartSamples: "Campioni",
    chartZipCodes: "Codici ZIP",
    chartParticipants: "Partecipanti",
    chartSuitableZips: "Codici ZIP Adatti",
    chartAveragePopulation: "Popolazione Media",
    chartAverageIncome: "Reddito Medio",
    
    // Demographic Values - Italian
    "10-19": "10-19",
    "20-29": "20-29",
    "30-39": "30-39",
    "40-49": "40-49",
    "50+": "50+",
    "18-29": "18-29",
    "30-44": "30-44", 
    "45-64": "45-64",
    "65+": "65+",
    "Male": "Maschio",
    "Female": "Femmina",
    "White": "Bianco",
    "Black": "Nero",
    "Hispanic": "Ispanico",
    "Asian": "Asiatico",
    "Other": "Altro",
    "Democrat": "Democratico",
    "Republican": "Repubblicano", 
    "Independent": "Indipendente",
    "Low": "Basso",
    "Medium": "Medio",
    "High": "Alto",
    "Rural": "Rurale",
    "Suburban": "Suburbano",
    "Urban": "Urbano",
    "1.0": "Meno del Liceo",
    "2.0": "Diplomato",
    "3.0": "Università Parziale",
    "4.0": "Laurea Triennale",
    "5.0": "Laurea Magistrale",
    "Less than $25,000": "Meno di $25,000",
    "$25,000 - $49,999": "$25,000 - $49,999",
    "$50,000 - $74,999": "$50,000 - $74,999",
    "$75,000 - $99,999": "$75,000 - $99,999",
    "$100,000+": "$100,000+",
    "All": "Tutti",
    
    // Home Page
    home: "Casa",
    homeTitle: "Politica di Precisione",
    homeSubtitle: "Intelligence Elettorale, Ingegnerizzata!",
    aboutThisPlatform: "Informazioni Su Questa Piattaforma",
    homeAboutParagraph1: "Precision Politics è una piattaforma di insights potenziata dall'IA che porta chiarezza al caos nei paesaggi politici moderni. Sintetizzando vasti dataset—sondaggi, legislazione, narrazioni mediatiche e tendenze demografiche—fornisce intelligence iper-mirata e in tempo reale a campagne, gruppi di advocacy e organizzazioni civic tech. Il risultato: messaggi più intelligenti, risposte più rapide e strategie basate sui dati che risuonano precisamente dove conta. Questa è intelligence elettorale progettata.",
    homeAboutParagraph2: "Attualmente fornisce un'interfaccia interattiva per analizzare i dati di approvazione di Trump attraverso tre caratteristiche principali: analisi di approvazione a livello statale, visualizzazione delle risposte ai sondaggi ed esplorazione dati grezzi.",
    electionIntelligenceTitle: "Analisi Approvazione Lavoro",
    electionIntelligenceDescription: "La nostra analisi più avanzata che impiega un modello su misura, gold-standard tra i sondaggisti, permettendo previsioni accurate fino alla granularità a livello statale con mappe interattive degli USA e filtri demografici.",
    surveyHeatmapDescription: "Visualizza il dataset stesso, mostrando potenziali lacune nei sondaggi tra i segmenti demografici. Aiuta a comprendere potenziali bias o distorsioni nei dati con statistiche in tempo reale e aggiornamenti dinamici.",
    rawDataDescription: "Espande le capacità di esplorazione dati, permettendo una chiara visualizzazione delle informazioni nazionali e dimostrando esattamente come i dati dei sondaggi si traducono negli USA nel loro complesso attraverso multiple tipologie di grafici.",
    stateLevelAnalysis: "Analisi a Livello Statale",
    geographicDistributionText: "Distribuzione Geografica",
    comprehensiveCharts: "Grafici Completi",
    exploreText: "Esplora",
  }
};

// Translation hook
export const useTranslation = (language) => {
  const translate = (key) => {
    return translations[language]?.[key] || translations.english[key] || key;
  };
  
  return translate;
}; 